import { RolePermissionModel } from '@/models/file-entities.model';
import { RouteType, ViewType } from '@/models/file-enum.model';
import router from '@/router';
import { getModulesAccess } from './Permissions';

const checkRouteRedirect = function(routeTo: any): void {
  if (router.currentRoute.path !== routeTo) {
    router.push(routeTo);
  }
};

// Redirect view depends of roles user
const redirectViewByRoles = function(
  roles: RolePermissionModel[],
  moduleName?: string
) {
  let view: any;
  const moduleList = getModulesAccess(roles, moduleName);

  if (!moduleName && moduleList.includes(moduleName!)) {
    view = moduleName!;
  } else if ( moduleList.includes(ViewType.Avisos)) {
    view = ViewType.Operaciones;
  } else if (moduleList.length > 0) {
    view = moduleList[0];
  } else {
    view = ViewType.Empty;
  }

  switch (view) {
    case ViewType.Users:
      checkRouteRedirect(RouteType.User);
      break;
    case ViewType.Operaciones:
      checkRouteRedirect(RouteType.Operaciones);
      break;
    case ViewType.Companies:
      checkRouteRedirect(RouteType.Company);
      break;
    case ViewType.Avisos:
      checkRouteRedirect(RouteType.Aviso);
      break;
    case ViewType.Empty:
      checkRouteRedirect(RouteType.Empty);
      break;
    default:
      checkRouteRedirect(RouteType.Login);
      break;
  }
};
export { redirectViewByRoles, checkRouteRedirect };
